import { createSlice } from "@reduxjs/toolkit";
import TransactionMonitorService from "../../../app/data/transaction-monitor/transactionMonitorService";
import { initialTransactionDefinitionsState } from "./TransactionDefinitionsState";
import { IState } from "../..";
import { AppThunk } from "../../../app/store";

const transactionMonitorService = TransactionMonitorService.getInstance();

export const transactionDefinitionsSlice = createSlice({
  name: "transactionDefinitions",
  initialState: initialTransactionDefinitionsState,
  reducers: {
    resetTransactionDefinitions: (state) => initialTransactionDefinitionsState,
    transactionDefinitionsLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    transactionDefinitionsLoadingSucceed: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.scopes = payload.scopes;
      state.types = payload.types;
      state.flows = payload.flows;
    },
    transactionDefinitionsLoadingFailed: (state) => {
      state.loading = false;
      state.loadingFailed = true;
      state.scopes = [];
    },
  },
});

export const {
  resetTransactionDefinitions,
  transactionDefinitionsLoadingStarted,
  transactionDefinitionsLoadingSucceed,
  transactionDefinitionsLoadingFailed,
} = transactionDefinitionsSlice.actions;

export const transactionDefinitionsSelector = (state: IState) => state.transactionDefinitions;

export const getTransactionDefinitions = (): AppThunk => async (dispatch) => {
  dispatch(transactionDefinitionsLoadingStarted());

  const response = await transactionMonitorService.getDifinitions();

  if (response.ok()) {
    dispatch(transactionDefinitionsLoadingSucceed(response.data));
  } else {
    dispatch(transactionDefinitionsLoadingFailed());
  }
};

const transactionDefinitionsReducer = transactionDefinitionsSlice.reducer;
export default transactionDefinitionsReducer;
